var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _path23, _g2, _path24, _g3, _path25, _g4, _path26, _g5, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgAdditionalDataPreviewEmpty = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 533,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.234 205.706V16.336l.447-2.1v189.37a22.892 22.892 0 0 1-.782 5.984c-.108.41-.22.816-.328 1.233.469-1.762.663-3.646.663-5.117Z",
    fill: "#B9CBD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M98.789 9.399c6.702-3.87 12.422-.764 12.445 6.937v189.37c.022 7.705-5.128 17.085-11.827 20.95l-76.39 44.105c-6.7 3.873-12.423.76-12.441-6.938V74.45c-.023-7.698 5.123-17.082 11.826-20.95L98.79 9.398Z",
    fill: "url(#additional-data-preview-empty_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.801 50.23 76.39-44.097c7.827-4.52 14.46-.898 14.486 8.103l-.447 2.1c-.023-7.7-5.742-10.806-12.445-6.937l-76.383 44.1C15.7 57.37 10.553 66.752 10.575 74.45v189.374c.019 7.701 5.742 10.811 12.442 6.938l76.39-44.101c1.415-.816 2.77-1.881 4.033-3.117-.302.291-.607.592-.909.89-1.475 1.445-3.057 2.689-4.714 3.642L21.43 272.176c-7.827 4.517-14.46.894-14.489-8.103V74.703c-.026-8.997 6.033-19.949 13.86-24.473Z",
    fill: "#B9CBD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.334 1.106c-2.58-1.497-6.148-1.281-10.088.986L13.86 46.197C6.029 50.717-.022 61.673 0 70.67v189.37c.015 4.469 1.858 7.615 4.402 9.094l6.945 4.032c-2.544-1.478-4.39-4.621-4.406-9.093V74.703c-.026-8.997 6.033-19.952 13.86-24.473l76.39-44.097c3.936-2.275 7.507-2.488 10.084-.995l-6.941-4.032Z",
    fill: "url(#additional-data-preview-empty_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m19.807 251.289 86.56-49.977V14.236l-86.56 49.973v187.08Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m5.336 113.211-4.77-2.756v-17.07l4.77 2.752v17.074ZM5.336 131.986l-4.77-2.759v-17.07l4.77 2.752v17.077Z",
    fill: "#2E2E2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m56.844 240.941 22.417-12.948c.942-.54 1.702-1.996 1.702-3.247s-.76-1.828-1.702-1.285l-22.417 12.94c-.942.544-1.702 2-1.702 3.251 0 1.259.76 1.832 1.702 1.289Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.631 136.51c23.077 47.568 29.605 83.723 59.224 74.368 12.53-3.962 25.768-8.847 35.067-17.464 6.773-6.271 10.78-13.778 20.607-14.396 21.382-1.337-1.862 18.92-8.315 25.355-8.68 8.665-22.261 18.749-33.06 24.935-26.808 15.36-56.099 13.644-92.361-32.513-6.629-8.438-26.011 31.853-24.741 19.237.826-8.196 23.385-71.095 29.92-71.046",
    fill: "url(#additional-data-preview-empty_svg__c)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.98 433.178s-4.602.581-7.954 3.206c-3.351 2.618-6.703 5.24-3.675 8.61 3.031 3.362 4.077 8.922 3.847 13.878-.239 4.953 4.274 9.906 9.778 14.292 4.469 3.557 7.135.216 7.932-1.761.778-1.977-.946-9.872-2.223-15.592-1.274-5.712-.138-16.965-.138-16.965l-7.567-5.668Z",
    fill: "url(#additional-data-preview-empty_svg__d)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m47.944 497.849-3.605 7.299a14.59 14.59 0 0 0-1.43 7.913c.443 4.417 1.27 11.075 2.432 14.009 1.817 4.58 10.605 6.185 14.06 5.05 3.45-1.136 2.79-9.943 1.718-19.253-.503-4.293-2.935-14.102-2.935-14.102l-10.24-.916Z",
    fill: "url(#additional-data-preview-empty_svg__e)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.847 499.659c-4.145-30.609 3.742-85.2 12.665-141.862l30.066-.603c-9.59 53.135-20.414 102.17-33.317 144.267-.004 0-5.873 3.411-9.414-1.802Z",
    fill: "url(#additional-data-preview-empty_svg__f)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.262 437.405c-.76-.942-.961-2.346-.235-3.315 34.747-46.279 46.142-67.117 69.304-101.198l-2.108 41.938c-18.82 31.399-25.419 39.476-58.791 65.092-1.65 1.266-3.888 1.422-5.523.153-.778-.607-1.664-1.468-2.647-2.67Z",
    fill: "url(#additional-data-preview-empty_svg__g)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.248 428.907c5.359 2.327 18.876 1.817 21.449 0 136.455-96.257-14.984-170.476-14.984-170.476l-47.475 13.235s-.391 29.961 3.154 43.68c1.05 4.063 126.542 21.632 37.856 113.561Z",
    fill: "#2E2E2E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.837 481.64c57.894-123.426 20.969-209.483 20.969-209.483l-60.102 23.028s40.284 13.812 18.652 187.538c4.044 1.628 15.413.779 20.481-1.083Z",
    fill: "#2E2E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.218 198.057c-1.642-41.81-7.272-80.315-23.784-86.604-6.155-2.342-51.187 15.983-52.475 17.156l-1.639.703c-18.288 7.649-17.442 38.437-15.971 56.397-4.897 47.851-.391 107.86 3.705 112.723 7.109 8.427 9.797 9.381 31.127 8.048 12.493-.782 38.653.063 55.343-9.336 16.698-9.41 5.336-57.335 3.694-99.087Z",
    fill: "url(#additional-data-preview-empty_svg__h)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m60.572 97.02-5.065 25.158-4.897 1.928c-2.249.883-2.807 3.799-1.024 5.426 7.537 6.863 24.767 20.6 35.034 13.346 6.896-4.871 5.35-16.414-1.062-29.582l-9.182-2.052.517-14.224H60.571Z",
    fill: "url(#additional-data-preview-empty_svg__i)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.867 76.155s-.142 17.971-1.449 26.439c-1.31 8.483-2.92 16.757-12.05 16.53-9.127-.223-18.258-6.062-24.804-20.779-6.55-14.727-3.568-26.338 2.647-31.667 6.212-5.332 33.872-3.701 35.656 9.477Z",
    fill: "url(#additional-data-preview-empty_svg__j)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.608 95.295s-1.746 2.38-2.65 3.773c-.898 1.389-2.987-3.225-7.5-11.12-4.518-7.89-5.653-21.672 1.184-24.677 6.833-3.005 5.429-4.324 9.075-8.502 3.645-4.174 7.518-4.982 19.695-2.89 12.188 2.097 15.293.258 17.773-2.423 12.293-13.261 23.181 18.484 10.338 14.999-4.536-1.236-.972 8.42-5.817 11.998-4.837 3.579-21.054 3.374-27.947 1.24-6.9-2.137-5.966 2.722-5.824 9.261.126 6.55-1.289 16.057 5.228 20.775 6.51 4.722 22.626-.923 22.626-.923s4.01 25.273-5.158 29.704c-19.334 9.329-24.584-11.748-28.11-25.712-2.093-8.293-2.913-15.503-2.913-15.503Z",
    fill: "#2E2E2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.792 94.96s-.306-7.265-5.158-7.298c-4.86-.026-3.474 8.363 1.944 12.094 5.41 3.721 3.214-4.796 3.214-4.796Z",
    fill: "url(#additional-data-preview-empty_svg__k)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.95 167.411c8.445 25.712 10.62 47.962 17.58 50.796 12.266 4.99 26.472-19.558 38.437-23.747 10.691-3.742 23.951-3.12 24.659-1.53 1.117 2.502-7.09 3.943-8.382 7.053-2.309 5.563-.916 12.024-12.87 13.845-12.124 1.847-36.098 38.478-48.197 35.577-22.227-5.333-40.27-69.482-32.05-79.138 5.335-6.275 14.958-7.481 20.305-3.732",
    fill: "url(#additional-data-preview-empty_svg__l)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.958 97.388c1.187 5.433 5.987 8.997 10.72 7.962 4.733-1.036 7.608-6.275 6.424-11.708-1.188-5.433-5.988-8.997-10.72-7.961-4.738 1.031-7.612 6.274-6.424 11.707Z",
    fill: "#FF0082"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.18 52.67S62.388 58.094 62.89 91.854c-3.966-.868-5.47-33.105 16.135-40.359 3.11-1.043 9.154.272 9.154 1.173ZM66.06 104.173s8.379 21.226 24.019 16.199c2.234 1.117 0 2.234 0 2.234s-13.964 6.703-26.253-17.316",
    fill: "#FF0082"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.474 122.055c.235 1.932 2.484 3.251 5.02 2.941 2.536-.309 4.401-2.126 4.167-4.062-.235-1.933-2.484-3.251-5.02-2.942-2.536.309-4.402 2.13-4.167 4.063Z",
    fill: "#FF0082"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m257.996 283.574-122.747 72.03-.004-.291 122.751-72.022v.283Z",
    fill: "#2E2E2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m135.55 346.179-.369.216-.004-.29.369-.213.004.287ZM256.834 275.006l-.73.432-.003-.287.729-.424.004.279Zm-1.46.86-.729.432-.004-.29.73-.432.003.29Zm-1.463.86-.73.425-.004-.283.73-.432.004.29Zm-1.46.857-.73.428-.003-.29.73-.429.003.291Zm-1.459.86-.73.425-.004-.287.734-.432v.294Zm-1.464.853-.733.428v-.287l.733-.424v.283Zm-1.46.856-.729.432-.004-.29.73-.428.003.286Zm-1.459.86-.734.425v-.283l.734-.428v.286Zm-1.464.857-.73.432v-.291l.73-.428v.287Zm-1.463.856-.73.425-.004-.287.73-.428.004.29Zm-1.46.857-.73.428-.004-.287.73-.424.004.283Zm-1.46.86-.73.425-.003-.287.73-.428.003.29Zm-1.463.853-.73.428v-.279l.73-.432v.283Zm-1.46.864-.73.432-.004-.294.73-.425.004.287Zm-1.463.853-.73.424-.004-.283.73-.432.004.291Zm-1.46.86-.73.428-.004-.291.73-.424.004.287Zm-1.46.86-.73.428-.003-.287.729-.432.004.291Zm-1.463.853-.73.428v-.287l.73-.428v.287Zm-1.464.86-.73.428-.003-.294.73-.428.003.294Zm-1.463.856-.723.425v-.283l.727-.428-.004.286Zm-1.456.857-.73.432v-.291l.73-.424v.283Zm-1.464.86-.729.428-.004-.287.73-.431.003.29Zm-1.459.853-.734.432-.004-.287.734-.428.004.283Zm-1.46.86-.73.428-.004-.287.73-.428.004.287Zm-1.464.856-.729.429-.004-.287.73-.428.003.286Zm-1.463.857-.73.432v-.291l.73-.428v.287Zm-1.456.856-.734.425-.003-.283.733-.432.004.29Zm-1.463.861-.734.428-.004-.287.734-.424.004.283Zm-1.46.856-.73.428-.004-.286.734-.432v.29Zm-1.464.86-.729.425v-.283l.729-.432v.29Zm-1.459.853-.73.432v-.291l.733-.424-.003.283Zm-1.464.86-.733.425v-.283l.729-.429.004.287Zm-1.46.857-.729.432v-.291l.729-.428v.287Zm-1.459.86-.734.424-.004-.283.734-.432.004.291Zm-1.464.853-.73.432-.003-.287.73-.425.003.28Zm-1.463.86-.73.432-.004-.287.73-.436.004.291Zm-1.46.856-.73.425-.004-.283.734-.428v.286Zm-1.46.857-.73.432-.003-.287.73-.428.003.283Zm-1.463.86-.73.428-.004-.29.73-.428.004.29Zm-1.46.856-.73.432v-.286l.73-.425v.279Zm-1.463.861-.73.424-.004-.287.73-.428.004.291Zm-1.464.852-.73.429-.003-.28.73-.432.003.283Zm-1.456.861-.73.428-.003-.291.73-.428.003.291Zm-1.463.86-.73.428v-.29l.73-.429v.291Zm-1.464.853-.73.431-.003-.29.73-.428.003.287Zm-1.459.86-.73.428v-.291l.73-.428v.291Zm-1.46.852-.73.432-.004-.286.73-.429.004.283Zm-1.464.861-.729.428-.004-.291.73-.424.003.287Zm-1.459.86-.73.424-.004-.283.73-.432.004.291Zm-1.46.856-.73.432v-.294l.734-.424-.004.286Zm-1.463.861-.73.424v-.287l.73-.428v.291Zm-1.46.849-.73.432v-.287l.73-.428v.283Zm-1.464.863-.73.429-.003-.291.73-.432.003.294Zm-1.459.857-.734.428v-.283l.73-.432.004.287Zm-1.464.856-.73.429-.003-.291.729-.424.004.286Zm-1.456.861-.733.424-.004-.287.733-.428.004.291Zm-1.463.852-.734.429-.004-.287.734-.425.004.283Zm-1.464.861-.73.432v-.291l.73-.432v.291Zm-1.459.86-.73.424-.004-.283.73-.432.004.291Zm-1.46.856-.73.432-.004-.294.734-.424v.286Zm-1.464.853-.73.432-.003-.287.73-.428.003.283Zm-1.459.86-.734.432-.004-.29.734-.425.004.283Zm-1.464.86-.73.429-.003-.287.729-.432.004.29Zm-1.46.849-.729.429v-.287l.729-.425v.283Zm-1.459.864-.73.432v-.29l.73-.432v.29Zm-1.464.857-.73.424-.003-.286.73-.429.003.291Zm-1.463.856-.73.432v-.29l.726-.428.004.286Zm-1.46.864-.73.425v-.291l.73-.428v.294Zm-1.463.849-.727.428-.003-.286.73-.425v.283Zm-1.46.86-.73.432-.004-.29.73-.432.004.29Zm-1.46.857-.73.428-.003-.283.729-.432.004.287Zm-1.463.856-.73.432-.004-.29.73-.425.004.283Zm-1.46.864-.734.425v-.283l.73-.432.004.29Zm-1.46.849-.73.432v-.286l.73-.425v.279Zm-1.463.864-.73.432-.004-.29.734-.432v.29Zm-1.464.857-.73.428v-.283l.73-.428v.283Zm-1.459.856-.73.432-.004-.29.73-.429.004.287Zm-1.46.857-.73.424v-.283l.73-.428v.287Zm-1.46.856-.733.428v-.286l.733-.432v.29Zm-1.463.86-.73.429-.004-.287.73-.432.004.29Zm-1.46.853-.734.432-.003-.283.733-.428.004.279Zm-1.463.864-.727.428-.003-.29.73-.432v.294Zm-1.464.853-.73.424-.004-.283.73-.432.004.291ZM257.933 274.365l-.369.216v-.286l.365-.216.004.286Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m257.869 265.157-122.751 72.025-.004-.29 122.752-72.022.003.287Z",
    fill: "#2E2E2E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m135.419 327.754-.365.212-.003-.279.365-.22.003.287ZM256.707 256.584l-.733.429v-.287l.73-.432.003.29Zm-1.463.861-.734.428v-.291l.73-.428.004.291Zm-1.463.856-.734.428v-.286l.73-.425.004.283Zm-1.46.86-.73.428-.004-.286.73-.428.004.286Zm-1.46.857-.734.428v-.287l.73-.428.004.287Zm-1.46.856-.733.432-.004-.29.734-.425.003.283Zm-1.463.857-.73.428-.004-.287.73-.428.004.287Zm-1.46.856-.733.432-.004-.287.733-.424.004.279Zm-1.463.86-.73.432-.004-.29.73-.432.004.29Zm-1.464.857-.73.424v-.283l.73-.428v.287Zm-1.459.856-.73.432v-.29l.733-.425-.003.283Zm-1.46.864-.73.428-.004-.286.73-.432.004.29Zm-1.464.853-.73.428-.003-.287.73-.424.003.283Zm-1.459.856-.73.425-.004-.287.726-.428.008.29Zm-1.464.861-.73.428-.003-.283.729-.432.004.287Zm-1.46.856-.729.428-.004-.286.73-.429.003.287Zm-1.459.857-.73.424v-.283l.73-.428v.287Zm-1.464.852-.73.432-.003-.29.73-.425.003.283Zm-1.46.864-.729.425v-.287l.729-.428v.29Zm-1.463.853-.726.428v-.287l.726-.428v.287Zm-1.46.86-.73.428-.003-.29.73-.428.003.29Zm-1.459.857-.73.424-.004-.283.73-.432.004.291Zm-1.464.856-.733.428-.004-.29.733-.428.004.29Zm-1.463.86-.73.425-.004-.287.73-.432.004.294Zm-1.46.853-.734.432-.003-.287.733-.424.004.279Zm-1.463.864-.73.428v-.286l.73-.432v.29Zm-1.456.853-.734.428-.004-.287.734-.428.004.287Zm-1.464.86-.734.432v-.291l.734-.424v.283Zm-1.46.86-.733.425-.004-.287.734-.432.003.294Zm-1.463.853-.73.432-.004-.287.73-.424.004.279Zm-1.46.86-.733.428-.004-.286.733-.432.004.29Zm-1.463.853-.734.432v-.287l.734-.428v.283Zm-1.464.864-.73.428-.003-.29.733-.425v.287Zm-1.456.856-.733.428-.004-.286.733-.429.004.287Zm-1.463.857-.734.428-.004-.291.734-.428.004.291Zm-1.464.856-.73.428-.003-.286.73-.429.003.287Zm-1.456.857-.73.428v-.287l.73-.424v.283Zm-1.463.856-.73.432-.004-.29.73-.429.004.287Zm-1.464.86-.729.425-.004-.283.73-.432.003.29Zm-1.456.857-.729.432-.004-.291.73-.428.003.287Zm-1.467.86-.73.425-.003-.287.726-.428.007.29Zm-1.46.853-.729.432-.004-.291.73-.424.003.283Zm-1.459.86-.73.432v-.291l.73-.432v.291Zm-1.464.856-.73.429-.003-.283.73-.432.003.286Zm-1.459.861-.73.428v-.291l.73-.428v.291Zm-1.46.86-.73.424-.004-.286.73-.432.004.294Zm-1.464.849-.729.432-.004-.287.73-.428.003.283Zm-1.459.86-.73.428-.004-.286.73-.432.004.29Zm-1.464.853-.73.432-.003-.287.729-.424.004.279Zm-1.46.864-.733.428v-.29l.733-.429v.291Zm-1.463.856-.73.425v-.283l.73-.429v.287Zm-1.46.857-.73.428v-.287l.73-.424v.283Zm-1.463.86-.73.424v-.286l.73-.432v.294Zm-1.46.853-.733.432-.004-.287.733-.425.004.28Zm-1.46.86-.729.428-.004-.29.73-.432.003.294Zm-1.463.856-.734.429v-.287l.73-.428.004.286Zm-1.46.857-.733.428-.004-.287.733-.424.004.283Zm-1.46.864-.733.424-.004-.287.73-.432.007.295Zm-1.463.852-.73.429-.004-.287.73-.428.004.286Zm-1.46.861-.733.428-.004-.291.734-.432.003.295Zm-1.463.856-.73.428v-.283l.73-.432v.287Zm-1.46.86-.733.429-.004-.295.733-.424.004.29Zm-1.463.853-.73.432-.004-.287.73-.432.004.287Zm-1.46.857-.73.431v-.29l.73-.424v.283Zm-1.46.86-.73.424-.003-.286.729-.429.004.291Zm-1.463.852-.73.432-.004-.283.73-.432.004.283Zm-1.46.861-.73.432-.004-.291.73-.424.004.283Zm-1.463.86-.73.424v-.283l.73-.428v.287Zm-1.46.853-.73.432-.004-.287.73-.432.004.287Zm-1.464.864-.729.424v-.287l.729-.432v.295Zm-1.459.849-.73.432v-.287l.73-.428v.283Zm-1.46.863-.73.429v-.291l.73-.428v.29Zm-1.464.857-.729.424-.004-.283.733-.431v.29Zm-1.459.856-.73.429-.004-.291.73-.428.004.29Zm-1.46.861-.734.428v-.287l.73-.432.004.291Zm-1.463.852-.73.429v-.287l.73-.425v.283Zm-1.46.864-.73.429v-.291l.73-.428v.29Zm-1.46.857-.733.424v-.283l.729-.432.004.291Zm-1.463.853-.73.431-.004-.29.734-.428v.287Zm-1.464.86-.73.428v-.287l.73-.428v.287Zm-1.46.856-.733.428-.004-.286.734-.425.003.283Zm-1.459.857-.73.428-.004-.287.73-.432.004.291Zm-1.464.86-.73.428v-.283l.73-.432v.287ZM257.802 255.944l-.368.212v-.283l.365-.216.003.287Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m257.739 246.735-122.751 72.022-.004-.283 122.751-72.03.004.291Z",
    fill: "#2E2E2E"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m135.29 309.339-.365.209-.004-.283.365-.22.004.294ZM256.574 238.166l-.73.432v-.29l.73-.428v.286Zm-1.46.861-.734.424-.003-.287.733-.428.004.291Zm-1.464.852-.729.429-.004-.291.73-.424.003.286Zm-1.459.861-.73.428-.004-.287.73-.432.004.291Zm-1.46.852-.73.429-.004-.283.734-.429v.283Zm-1.46.861-.73.431-.003-.294.733-.42v.283Zm-1.463.856-.73.428-.004-.283.73-.428.004.283Zm-1.46.856-.734.432-.003-.29.733-.425.004.283Zm-1.46.861-.73.428v-.287l.73-.432v.291Zm-1.467.856-.73.428-.003-.29.729-.425.004.287Zm-1.456.86-.73.432v-.294l.73-.428v.29Zm-1.463.853-.73.428-.004-.283.73-.432.004.287Zm-1.464.86-.73.429-.003-.291.73-.424.003.286Zm-1.459.857-.73.428v-.287l.73-.432v.291Zm-1.46.856-.73.432v-.287l.73-.428v.283Zm-1.464.86-.73.429-.003-.291.73-.432.003.294Zm-1.459.857-.73.424-.004-.283.73-.432.004.291Zm-1.464.856-.73.429v-.287l.73-.428v.286Zm-1.46.861-.729.428-.004-.283.73-.432.003.287Zm-1.463.852-.73.429-.004-.283.727-.429.007.283Zm-1.46.864-.73.425-.003-.287.733-.432v.294Zm-1.463.849-.73.432-.004-.286.73-.429.004.283Zm-1.456.864-.734.428-.004-.286.734-.432.004.29Zm-1.464.857-.73.424-.003-.287.73-.428.003.291Zm-1.459.852-.734.436-.004-.29.734-.429.004.283Zm-1.468.864-.729.429-.004-.287.73-.428.003.286Zm-1.456.853-.733.428v-.286l.733-.429v.287Zm-1.463.86-.73.432-.004-.29.734-.428v.286Zm-1.46.857-.73.424-.003-.283.733-.432v.291Zm-1.463.856-.73.432v-.294l.73-.428v.29Zm-1.46.86-.73.425-.004-.287.734-.432v.294Zm-1.46.853-.733.432-.004-.287.734-.428.003.283Zm-1.463.86-.73.432-.004-.29.73-.432.004.29Zm-1.46.857-.733.424v-.279l.729-.432.004.287Zm-1.463.856-.734.432-.004-.294.734-.424.004.286Zm-1.464.861-.73.428-.003-.283.73-.432.003.287Zm-1.456.856-.73.428-.003-.286.73-.429.003.287Zm-1.463.856-.73.429-.004-.287.73-.432.004.29Zm-1.464.857-.73.432-.003-.287.73-.428.003.283Zm-1.459.86-.73.432v-.29l.73-.432v.29Zm-1.46.857-.73.428-.004-.283.73-.432.004.287Zm-1.464.856-.729.428-.004-.29.73-.425.003.287Zm-1.459.86-.73.429-.004-.291.73-.432.004.294Zm-1.46.853-.73.432-.004-.287.73-.428.004.283Zm-1.464.86-.729.428v-.29l.729-.432v.294Zm-1.463.86-.726.429-.004-.287.73-.432v.29Zm-1.46.857-.73.424v-.286l.73-.429v.291Zm-1.463.856-.73.429v-.287l.73-.432v.29Zm-1.456.857-.73.428-.004-.287.73-.424.004.283Zm-1.464.86-.729.432-.004-.29.73-.432.003.29Zm-1.463.857-.73.424-.004-.283.73-.428.004.287Zm-1.46.856-.73.428-.003-.29.73-.428.003.29Zm-1.459.856-.73.425v-.283l.73-.428v.286Zm-1.464.861-.73.428-.004-.287.734-.424v.283Zm-1.463.856-.73.425-.004-.287.73-.432.004.294Zm-1.456.857-.73.432-.004-.287.734-.425v.28Zm-1.464.86-.733.432-.004-.291.733-.428.004.287Zm-1.46.856-.729.425-.004-.283.733-.428v.286Zm-1.459.857-.734.432v-.294l.73-.425.004.287Zm-1.464.86-.733.428v-.287l.73-.431.003.29Zm-1.463.849-.73.432-.004-.287.73-.428.004.283Zm-1.46.864-.734.432-.003-.291.733-.428.004.287Zm-1.46.856-.73.429-.003-.283.73-.432.003.286Zm-1.463.857-.73.432-.004-.291.73-.424.004.283Zm-1.46.86-.73.428v-.29l.73-.432v.294Zm-1.463.857-.73.428-.004-.287.73-.428.004.287Zm-1.46.856-.73.428-.004-.29.73-.428.004.29Zm-1.46.856-.73.429-.003-.283.729-.432.004.286Zm-1.463.861-.73.428-.004-.294.73-.425.004.291Zm-1.464.86-.73.424v-.286l.73-.429v.291Zm-1.459.853-.73.428-.004-.287.73-.428.004.287Zm-1.46.86-.73.424v-.286l.73-.429v.291Zm-1.46.853-.733.432-.004-.287.733-.428.004.283Zm-1.463.86-.73.428v-.29l.73-.432v.294Zm-1.46.856-.734.429v-.287l.734-.432v.29Zm-1.467.86-.73.429-.004-.291.734-.428v.29Zm-1.456.857-.73.424-.004-.286.73-.429.004.291Zm-1.46.853-.734.432v-.287l.73-.425.004.28Zm-1.463.864-.73.432-.004-.291.734-.432v.291Zm-1.464.852-.73.425v-.283l.73-.428v.286Zm-1.46.861-.729.432-.004-.295.733-.424v.287Zm-1.459.86-.73.424-.004-.286.73-.429.004.291Zm-1.464.852-.73.429-.003-.287.733-.425v.283ZM257.672 237.526l-.369.208v-.283l.369-.219v.294Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m257.609 228.313-122.751 72.022-.004-.283 122.751-72.029.004.29Z",
    fill: "#2E2E2E"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fill: "#2E2E2E"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m135.159 290.914-.365.212-.003-.286.368-.216v.29ZM256.447 219.741l-.73.432-.004-.29.73-.432.004.29Zm-1.463.86-.73.429v-.283l.73-.432v.286Zm-1.464.857-.73.432-.003-.294.729-.425.004.287Zm-1.46.86-.73.424v-.286l.73-.432v.294Zm-1.459.853-.734.432v-.287l.73-.428.004.283Zm-1.46.86-.734.428v-.287l.734-.432v.291Zm-1.464.856-.729.425v-.283l.729-.428v.286Zm-1.459.857-.734.432-.004-.294.734-.421.004.283Zm-1.46.86-.73.425-.004-.283.73-.432.004.29Zm-1.463.857-.73.428v-.283l.73-.429v.284Zm-1.46.856-.734.428v-.283l.734-.432v.287Zm-1.464.856-.73.432v-.286l.73-.425v.279Zm-1.459.861-.73.428-.004-.291.73-.424.004.287Zm-1.464.856-.73.425-.003-.283.729-.429.004.287Zm-1.46.86-.729.425-.004-.291.73-.424.003.29Zm-1.463.857-.73.428-.004-.287.73-.432.004.291Zm-1.46.853-.73.428-.003-.287.73-.428.003.287Zm-1.459.86-.73.428-.004-.287.73-.432.004.291Zm-1.464.86-.73.424-.004-.283.73-.432.004.291Zm-1.463.856-.727.429v-.291l.727-.428v.29Zm-1.46.857-.73.424-.004-.286.734-.432v.294Zm-1.46.853-.73.432v-.287l.73-.428v.283Zm-1.463.864-.73.428-.004-.287.734-.432v.291Zm-1.46.852-.73.432v-.283l.73-.432v.283Zm-1.46.861-.733.431-.004-.29.734-.424.003.283Zm-1.463.86-.73.428-.004-.287.73-.432.004.291Zm-1.456.852-.734.432-.004-.286.734-.429.004.283Zm-1.467.861-.73.424-.004-.29.734-.429v.295Zm-1.46.856-.734.428-.003-.286.733-.429.004.287Zm-1.464.857-.729.432v-.291l.729-.428v.287Zm-1.456.86-.733.424-.004-.283.734-.432.003.291Zm-1.463.856-.734.429v-.291l.73-.424.004.286Zm-1.463.857-.73.432-.004-.291.73-.428.004.287Zm-1.46.856-.734.428-.004-.286.734-.429.004.287Zm-1.464.86-.73.429-.003-.291.733-.428v.29Zm-1.459.857-.73.424v-.283l.73-.432v.291Zm-1.46.856-.73.432-.004-.29.73-.428.004.286Zm-1.464.861-.729.424v-.287l.729-.432v.295Zm-1.463.852-.73.432-.004-.286.73-.425.004.279Zm-1.46.861-.726.428-.004-.291.73-.432v.295Zm-1.459.856-.73.428v-.283l.73-.432v.287Zm-1.464.856-.73.429-.004-.287.73-.428.004.286Zm-1.46.857-.73.428v-.283l.727-.432.003.287Zm-1.463.86-.73.428-.004-.286.73-.425.004.283Zm-1.46.86-.73.429v-.287l.726-.432.004.29Zm-1.46.853-.729.428v-.286l.729-.425v.283Zm-1.463.86-.73.432v-.29l.73-.432v.29Zm-1.463.857-.73.424v-.283l.73-.428v.287Zm-1.46.856-.73.432v-.294l.73-.424v.286Zm-1.46.86-.73.425v-.287l.734-.432-.004.294Zm-1.463.853-.73.432-.004-.29.73-.425.004.283Zm-1.46.86-.73.432-.004-.29.73-.432.004.29Zm-1.464.861-.729.424v-.279l.729-.432v.287Zm-1.459.856-.734.432v-.29l.734-.429v.287Zm-1.46.857-.73.424v-.287l.73-.428v.291Zm-1.46.856-.733.432v-.291l.733-.428v.287Zm-1.463.86-.734.428-.004-.286.734-.432.004.29Zm-1.46.857-.73.424v-.283l.73-.432v.291Zm-1.463.856-.73.428-.004-.29.73-.425.004.287Zm-1.464.857-.73.424-.003-.283.733-.428v.287Zm-1.46.852-.729.436v-.29l.729-.432v.286Zm-1.459.864-.734.425v-.287l.73-.432.004.294Zm-1.46.853-.73.432v-.287l.73-.424v.279Zm-1.464.86-.729.432-.004-.29.73-.428.003.286Zm-1.459.86-.73.429v-.287l.73-.428v.286Zm-1.464.853-.726.432-.004-.294.73-.428v.29Zm-1.459.86-.73.429-.004-.287.73-.428.004.286Zm-1.46.853-.73.432-.004-.287.73-.428.004.283Zm-1.464.864-.729.432-.004-.29.73-.429.003.287Zm-1.463.857-.73.424-.004-.283.73-.432.004.291Zm-1.456.856-.734.428v-.29l.73-.425.004.287Zm-1.467.86-.73.428v-.286l.73-.432v.29Zm-1.456.853-.734.432-.004-.287.734-.424.004.279Zm-1.464.864-.73.424v-.286l.73-.429v.291Zm-1.459.853-.734.428v-.287l.734-.428v.287Zm-1.464.856-.73.428-.003-.29.729-.425.004.287Zm-1.46.86-.729.425-.004-.283.73-.428.003.286Zm-1.459.857-.734.428-.004-.29.73-.425.008.287Zm-1.46.856-.734.428-.003-.286.733-.428.004.286Zm-1.464.857-.729.432-.004-.291.73-.424.003.283Zm-1.463.86-.73.428-.004-.29.73-.429.004.291Zm-1.46.853-.73.428-.003-.283.73-.432.003.287Zm-1.463.86-.73.432-.004-.294.73-.425.004.287ZM257.545 219.104l-.368.209-.004-.287.369-.216.003.294Z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m257.478 209.895-122.751 72.019-.004-.287 122.752-72.026.003.294Z",
    fill: "#2E2E2E"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M118.469 347.888s4.543-45.17 19.245-53.798c14.709-8.631 8.937 22.909 22.089 15.194 10.434-6.122 9.582-53.21 23.266-61.238 13.685-8.033 12.576 29.943 22.608 24.059 10.032-5.883 4.148-20.023 18.135-28.226 13.982-8.204 17.408 31.983 17.408 31.983l-122.751 72.026Z",
    fill: "url(#additional-data-preview-empty_svg__m)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m137.256 337.007-.242.145-.302-42.633.242-.142.302 42.63Z",
    fill: "url(#additional-data-preview-empty_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M138.209 336.687c.004.618-.473 1.396-1.065 1.743-.592.346-1.076.134-1.08-.484-.004-.615.473-1.401 1.065-1.747.592-.346 1.076-.126 1.08.488Z",
    fill: "url(#additional-data-preview-empty_svg__o)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M137.907 293.819c.004.614-.476 1.396-1.065 1.742-.592.347-1.076.127-1.08-.484-.003-.622.473-1.396 1.065-1.746.593-.347 1.077-.131 1.08.488Z",
    fill: "url(#additional-data-preview-empty_svg__p)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m184.045 309.552-.242.141-.436-61.517.242-.142.436 61.518Z",
    fill: "url(#additional-data-preview-empty_svg__q)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M185.002 309.228c.004.622-.473 1.4-1.065 1.75-.592.346-1.076.134-1.083-.488-.004-.614.472-1.396 1.065-1.743.592-.35 1.079-.13 1.083.481Z",
    fill: "url(#additional-data-preview-empty_svg__r)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M184.566 247.472c.004.618-.473 1.4-1.068 1.75-.592.347-1.077.131-1.08-.487-.004-.619.473-1.397 1.065-1.743.596-.354 1.08-.134 1.083.48Z",
    fill: "url(#additional-data-preview-empty_svg__s)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m224.281 285.943-.242.145-.294-41.554.242-.145.294 41.554Z",
    fill: "url(#additional-data-preview-empty_svg__t)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M225.234 285.626c.004.611-.473 1.4-1.065 1.747-.592.346-1.076.126-1.08-.488-.004-.615.473-1.397 1.065-1.747.592-.346 1.076-.134 1.08.488Z",
    fill: "url(#additional-data-preview-empty_svg__u)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M224.94 243.83c.004.618-.473 1.4-1.065 1.747-.592.346-1.076.134-1.08-.484-.004-.618.473-1.397 1.065-1.747.592-.346 1.076-.134 1.08.484Z",
    fill: "url(#additional-data-preview-empty_svg__v)"
  })))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M135.245 355.321s4.733-18.012 19.442-26.636c14.705-8.632 8.397-53.552 21.55-61.276 10.43-6.121 10.065 15.946 23.754 7.91 13.685-8.032 12.549 26.454 22.581 20.57 10.032-5.887 4.085-29.064 18.072-37.271C254.626 250.414 258 283.295 258 283.295l-122.755 72.026Z",
    fill: "url(#additional-data-preview-empty_svg__w)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m154.031 344.432-.242.149-.108-15.472.242-.138.108 15.461Z",
    fill: "url(#additional-data-preview-empty_svg__x)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M154.985 344.116c.003.618-.473 1.396-1.065 1.746-.593.35-1.077.134-1.08-.484-.004-.614.473-1.4 1.065-1.746.592-.346 1.076-.127 1.08.484Z",
    fill: "url(#additional-data-preview-empty_svg__y)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M154.877 328.405c.003.615-.473 1.4-1.065 1.75-.592.347-1.08.127-1.08-.487-.004-.618.473-1.401 1.065-1.751.588-.346 1.072-.126 1.08.488Z",
    fill: "url(#additional-data-preview-empty_svg__z)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m200.821 316.981-.242.145-.294-41.677.242-.141.294 41.673Z",
    fill: "url(#additional-data-preview-empty_svg__A)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M201.778 316.66c.004.619-.473 1.401-1.069 1.747-.592.346-1.076.13-1.08-.488-.003-.614.473-1.396 1.065-1.743.596-.35 1.08-.13 1.084.484Z",
    fill: "url(#additional-data-preview-empty_svg__B)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M201.484 274.749c.004.618-.473 1.396-1.065 1.75-.592.347-1.076.131-1.08-.488-.004-.618.473-1.4 1.065-1.746.588-.35 1.076-.127 1.08.484Z",
    fill: "url(#additional-data-preview-empty_svg__C)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m241.057 293.372-.242.145-.242-34.24.245-.146.239 34.241Z",
    fill: "url(#additional-data-preview-empty_svg__D)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M242.01 293.055c.007.611-.473 1.4-1.065 1.747-.589.346-1.077.126-1.08-.492-.004-.614.473-1.393 1.065-1.746.592-.343 1.076-.127 1.08.491Z",
    fill: "url(#additional-data-preview-empty_svg__E)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M241.768 258.573c.003.618-.477 1.4-1.065 1.746-.592.343-1.08.131-1.08-.491-.004-.611.473-1.397 1.061-1.743.596-.343 1.08-.127 1.084.488Z",
    fill: "url(#additional-data-preview-empty_svg__F)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.158 210.091c.655-.409 84.918-49.116 85.856-49.072.149.008.231.026.231.026.428.09.618.272 3.344 1.858-.607-.35-1.363-.156-1.966.194-70.794 40.876-84.951 48.685-85.975 50.078-1.661 2.268-.633 71.553-1.147 103.641.003.692.234 1.426.834 1.772-3.106-1.806-3.731-1.832-3.735-3.474l-.082-100.319c0-1.728 1.18-3.791 2.64-4.704Z",
    fill: "#BDCCD4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M161.397 164.68c-.003-1.754-1.247-2.462-2.77-1.579l-84.426 48.622c-1.527.882-2.704 3.016-2.7 4.77v100.319c.007 1.754 1.273 2.461 2.8 1.579l84.423-48.626c1.523-.878 2.759-3.016 2.755-4.77l-.082-100.315Z",
    fill: "#BDCCD4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.909 195.755c1.955-1.128 3.537-.22 3.545 2.018.007 2.242-1.568 4.971-3.523 6.1l-19.133 11.045c-1.951 1.124-3.537.223-3.545-2.019-.007-2.242 1.572-4.971 3.523-6.099l19.133-11.045ZM120.308 256.33c.607-.35 1.099-.067 1.099.625.004.697-.484 1.542-1.091 1.896l-7.053 4.07c-.607.35-1.099.071-1.102-.626-.004-.692.487-1.541 1.094-1.891l7.053-4.074ZM110.076 262.24c.603-.347 1.098-.067 1.098.625.004.7-.488 1.546-1.091 1.892l-1.221.704c-.604.35-1.095.07-1.095-.63-.004-.692.488-1.541 1.087-1.891l1.222-.7ZM125.902 253.101c.607-.35 1.098-.067 1.098.626.004.696-.484 1.542-1.091 1.892l-2.536 1.463c-.607.35-1.098.071-1.098-.626 0-.692.484-1.541 1.094-1.891l2.533-1.464ZM145.046 228.364c2.182-1.259 3.955-.249 3.962 2.253.007 2.506-1.754 5.556-3.936 6.815L90.809 268.76c-2.179 1.259-3.951.246-3.955-2.26-.007-2.503 1.754-5.553 3.932-6.811l54.26-31.325Z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M113.639 234.706c1.14-.659 2.071-.131 2.074 1.18.004 1.311-.923 2.909-2.059 3.564l-20.7 11.95c-1.14.659-2.067.13-2.07-1.181-.005-1.311.915-2.904 2.058-3.564l20.697-11.949Z",
    fill: "#5ABAB8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M144.852 214.27c2.182-1.259 3.955-.25 3.962 2.256.008 2.503-1.754 5.556-3.936 6.815l-54.263 31.328c-2.178 1.259-3.951.242-3.959-2.26-.007-2.506 1.754-5.556 3.933-6.811l54.263-31.328Zm.279 5.924c.745-.428 1.341-1.463 1.337-2.312-.004-.853-.603-1.196-1.348-.764l-9.157 5.288c-.741.428-1.336 1.464-1.336 2.313.003.852.603 1.191 1.344.767l9.16-5.292Z",
    fill: "#FF0082"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.199 225.136c1.14-.66 2.067-.127 2.071 1.184.003 1.311-.916 2.904-2.056 3.563l-13.301 7.679c-1.14.659-2.067.13-2.07-1.181-.004-1.31.915-2.912 2.055-3.567l13.301-7.678Z",
    fill: "#5ABAB8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M145.124 217.115c.745-.429 1.344-.086 1.348.763.003.849-.596 1.884-1.337 2.312l-9.157 5.288c-.741.428-1.34.086-1.344-.767-.004-.853.596-1.884 1.337-2.312l9.153-5.284ZM144.968 200.492c2.182-1.259 3.954-.25 3.962 2.256.007 2.503-1.754 5.556-3.936 6.815l-54.263 31.328c-2.179 1.259-3.951.242-3.955-2.26-.007-2.506 1.754-5.556 3.932-6.815l54.26-31.324Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M103.574 227.511c.745-.428 1.344-.085 1.348.764.004.849-.596 1.884-1.337 2.312l-9.157 5.288c-.74.428-1.34.086-1.344-.767-.004-.853.596-1.884 1.337-2.313l9.153-5.284Z",
    fill: "#FF0082"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M135.107 259.015c-.142-.082-3.057-1.803-3.221-1.829a.74.74 0 0 0-.257.004c-.082.015-.156.041-.149.037-.249.079-4.565 2.607-4.685 2.7a2.694 2.694 0 0 0-.919 1.516c-.011.048-.015.074-.015.074-.03.175-.034 5.098.011 5.366.045.272.19.462.32.54l3.028 1.758c-.242-.142-.339-.473-.343-.749-.015-4.807-.067-4.967.075-5.44.193-.648.644-1.199 1.076-1.452.175-.101 4.278-2.488 4.472-2.555.209-.067.428-.078.607.03Z",
    fill: "#009983"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M134.273 259.097c.652-.376 1.177-.075 1.18.67l.015 4.867c.004.741-.521 1.65-1.173 2.026l-4.234 2.443c-.648.372-1.173.074-1.176-.671l-.015-4.863c-.004-.748.521-1.653 1.165-2.026l4.238-2.446Z",
    fill: "#00AF9B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M126.725 263.871c-.142-.082-3.058-1.803-3.221-1.829a.74.74 0 0 0-.257.004c-.082.015-.157.041-.149.037-.25.078-4.566 2.607-4.685 2.7a2.695 2.695 0 0 0-.92 1.516c-.011.048-.015.074-.015.074-.029.175-.033 5.098.012 5.366.044.272.19.462.324.536l3.027 1.758c-.242-.142-.343-.473-.343-.752-.014-4.808-.067-4.968.075-5.441.194-.648.644-1.199 1.076-1.448.175-.101 4.279-2.488 4.472-2.555.205-.063.421-.071.604.034Z",
    fill: "url(#additional-data-preview-empty_svg__G)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M125.887 263.953c.651-.377 1.177-.075 1.18.67l.015 4.867c.004.741-.521 1.649-1.169 2.022l-4.234 2.443c-.648.372-1.173.074-1.177-.671l-.015-4.863c0-.748.522-1.653 1.17-2.026l4.23-2.442Z",
    fill: "#FF0082"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M118.343 268.726c-.142-.081-3.058-1.802-3.221-1.828a.74.74 0 0 0-.257.004c-.082.015-.157.041-.149.037-.25.078-4.566 2.607-4.685 2.7a2.696 2.696 0 0 0-.92 1.515l-.015.075c-.026.175-.033 5.098.012 5.366.044.272.189.462.32.536l3.027 1.758c-.242-.142-.342-.473-.342-.753-.015-4.807-.067-4.967.074-5.44.194-.648.644-1.199 1.076-1.452.175-.101 4.279-2.488 4.473-2.555.204-.059.424-.067.607.037Z",
    fill: "#62007A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M117.504 268.808c.652-.376 1.177-.074 1.181.671l.015 4.863c0 .745-.522 1.65-1.173 2.026l-4.234 2.442c-.648.373-1.173.075-1.177-.67l-.015-4.867c0-.748.521-1.653 1.169-2.026l4.234-2.439Z",
    fill: "#2E2E2E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 273.582c-.142-.082-3.058-1.802-3.221-1.828a.74.74 0 0 0-.257.004c-.082.015-.157.041-.149.037-.25.078-4.566 2.607-4.685 2.7a2.683 2.683 0 0 0-.935 1.59c-.029.175-.033 5.098.012 5.366.044.272.189.461.32.536l3.027 1.758c-.242-.138-.342-.473-.342-.753-.015-4.807-.067-4.967.074-5.44.194-.648.644-1.199 1.076-1.449.175-.104 4.279-2.487 4.473-2.554.208-.06.428-.071.607.033Z",
    fill: "#FF0082"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M109.122 273.664c.652-.376 1.177-.074 1.177.67l.015 4.864c.004.744-.521 1.649-1.169 2.025l-4.234 2.443c-.648.373-1.173.075-1.177-.67l-.015-4.86c-.003-.748.522-1.653 1.166-2.025l4.237-2.447Z",
    fill: "#FF0082"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M180.563 138.052s-7.157-4.241-9.484-5.493c-1.337-.718-2.748-.796-3.597.045-.466.466-2.473 2.73-2.473 2.73v.003c.853-.819 2.245-.737 3.571-.026 2.331 1.252 9.485 5.493 9.485 5.493 3.656 2.692 3.966 5.783 3.921 12.527-.116 17.911.004 43.498-.138 60.791.045.637-.115 1.18-.402 1.605l.004.004s1.199-1.427 1.716-2.045c.555-.655 1.177-1.299 1.181-2.316.007-5.843.018-42.883.138-60.791.044-6.744-.269-9.835-3.922-12.527Z",
    fill: "url(#additional-data-preview-empty_svg__H)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M204.102 121.355s-7.247-4.488-9.872-5.694c-1.225-.562-3.113-.238-4.063.711-.342.343-1.273 1.199-2.07 2.376.759-.987 2.159-1.02 3.496-.406 2.622 1.207 10.01 5.764 10.01 5.764 2.141 1.587 3.534 3.501 3.731 6.726-.089 24.964-.29 71.716-.35 96.096-.004 1.113-.51 2.044-1.281 2.562 1.009-.596 2.119-2.301 2.633-2.845.592-.626 1.147-1.419 1.147-2.473.059-24.383.257-71.132.35-96.096-.198-3.221-1.594-5.135-3.731-6.721Z",
    fill: "url(#additional-data-preview-empty_svg__I)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M232.153 112.443c0-2.383-1.757-3.664-3.314-4.651-2.353-1.489-7.116-3.876-9.79-5.321-1.393-.752-2.58-.428-3.53.238-.499.351-2.804 2.108-2.942 3.05.756-1.657 2.29-1.802 3.944-.908 2.673 1.445 9.823 5.697 9.823 5.697 1.49 1.087 3.314 2.264 3.314 4.651 0 28.089.019 123.075 0 126.434-.007 1.356-.625 2.294-1.556 2.603 1.121-.141 2.629-2.394 3.057-3.035.421-.633.99-1.258.998-2.323.015-3.359-.004-98.346-.004-126.435Z",
    fill: "url(#additional-data-preview-empty_svg__J)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M178.065 140.804c3.656 2.692 3.965 5.783 3.921 12.527-.119 17.911.003 43.498-.138 60.791.153 2.234-2.138 3.34-4.029 2.104l-3.221-1.858c-8.833-5.154-10.241-3.951-10.524-13.153 0-4.792.064-61.011.119-63.58.064-3.013 2.317-3.433 4.383-2.32 2.331 1.248 9.489 5.489 9.489 5.489Zm13.528-22.462c-1.962-.901-4.066-.41-4.066 2.439 0 1.959-.023 7.828-.023 7.828s-.096 65.043-.096 86.38c0 6.588 1.91 7.854 3.965 9.12.715.439 5.962 3.426 9.373 5.381 2.134 1.221 4.23-.294 4.234-2.566.06-24.383.257-71.132.35-96.096-.197-3.225-1.59-5.139-3.731-6.725.004.003-7.384-4.554-10.006-5.761Zm24.92-13.491c-2.045-1.103-4.245-.652-4.338 2.338-.064 2.13-.023 7.828-.023 7.828s-.108 85.431-.097 113.877c.004 6.182.794 7.563 3.914 9.403 1.557.92 7.284 4.237 9.827 5.612 2.089 1.128 3.839.014 3.854-2.279.019-3.359 0-98.346 0-126.435 0-2.383-1.824-3.56-3.314-4.651.004 0-7.146-4.252-9.823-5.693Z",
    fill: "url(#additional-data-preview-empty_svg__K)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M183.849 71.85s-7.786-1.792-7.898-8.368c-.06-3.404 1.028-5.206 4.122-6.703 2.167-1.05 3.325-5.578 9.619-4.253 5.183 1.092 6.788 4.305 6.148 9.552-.887 7.261-8.278 9.257-8.278 9.257l-3.713.514Z",
    fill: "url(#additional-data-preview-empty_svg__L)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M185.897 66.144c.172.496.488.924.913 1.233 1.158.845 2.495 3.541 2.889 8.74.671 8.855 11.164 3.992 15.536 25.582.246 1.207 8.26-4.405 5.977-10.37-3.985-10.416.413-11.756-2.48-16.623-2.439-4.1-7.701-1.624-9.157-11.317-.976-6.487-6.465-12.203-12.132-9.675-4.692 2.097-2.458 9.82-1.546 12.43Z",
    fill: "url(#additional-data-preview-empty_svg__M)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M186.832 60.857s-6.323-3.177-9.302 2.286c-.994 2.316-1.125 5.731 4.171 7.883a2750.294 2750.294 0 0 1-2.316-6.125s.104-2.48 7.447-4.044Z",
    fill: "url(#additional-data-preview-empty_svg__N)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M171.14 85.914s.733-6.714 3.802-8.576c2.446-1.486 4.476-4.554 3.925-5.682-.54-1.103-4.16-2.857-5.556-2.425-1.397.432-2.488 4.048-2.95 6.268-.461 2.215-4.502 7.753-4.502 7.753s4.335 3.57 5.281 2.662Z",
    fill: "url(#additional-data-preview-empty_svg__O)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m175.165 75.871-3.679-3.325a.494.494 0 0 1-.011-.727l6.718-6.684a.5.5 0 0 1 .693 0l3.5 3.318a.496.496 0 0 1 .007.715l-6.542 6.692a.502.502 0 0 1-.686.011Z",
    fill: "#2E2E2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M166.798 80.768c.834-1.237 2.432.502 4.811 3.545 0 0-.696 7.775.581 9.79.659-.6 1.221-1.639 1.422-3.426.28-2.447.552-4.022 2.879-8.502 2.353-4.52 6.051-5.995 6.051-5.995s-3.091 9.555-3.902 13.208c-1.754 7.872-2.175 12.166-4.231 13.693-1.318.975-4.2 2.789-7.607-1.717-3.832-5.08-3.192-15.878-.004-20.596Z",
    fill: "#62007A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M168.102 172.053s.096.458 1.422 1.385c.559.391 1.262.529 2.249 1.374 1.929 1.65-2.741 4.651-4.074 8.018-.811 2.044-3.787 2.368-4.874 1.843-1.091-.521-.149-2.439 1.638-4.443 1.784-2.003 1.043-4.699 1.043-4.699l2.596-3.478ZM178.062 177.817s.131 1.155.552 1.937c.357.651 1.288 1.884 1.351 2.361.194 1.355-3.388 3.56-5.358 6.021-1.575 1.966-8.252 2.368-5.255-1.165 2.912-3.426 4.707-5.59 4.778-7.835.082-2.54 3.932-1.319 3.932-1.319Z",
    fill: "#2E2E2E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M179.526 115.295s-31.012 12.363-30.185 21.028c.827 8.665 10.356 31.321 16.154 39.234 1.806-.275 2.997-2.055 2.677-3.415-2.145-9.425-5.28-30.684-7.675-32.501 16.884-5.355 33.533-15.268 33.533-15.268l-9.06-7.942-5.444-1.136Z",
    fill: "#00AF9B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M198.294 116.624c-18.709 11.734-35.175 25.289-34.445 30.524.584 4.178 1.307 10.587 10.326 32.498.447 1.303 3.653 1.456 4.1-.518-2.775-13.655.42-24.495-3.478-29.742 10.97-6.874 31.734-7.101 28.23-28.468-1.363-8.319-4.733-4.294-4.733-4.294Z",
    fill: "#00AF9B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M186.266 73.901s-4.316 1.374-6.446 5.47c-2.108 4.052-3.75 12.166-4.238 14.754-.089.477-.588 7.209-.149 7.422.857 2.234.008 24.655 2.801 24.431.752-19.188 8.032-52.077 8.032-52.077Z",
    fill: "#2E2E2E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M195.583 103.747s6.863 12.609 7.585 17.96c.723 5.351-18.418.343-18.418.343l-6.114-4.741 1.597-16.328 15.35 2.766Z",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M198.428 104.868v.019c.145 1.095-.525 2.134-1.601 2.376-5.664 1.262-12.769-4.097-16.59-6.282-1.407-.805-2.473-4.298-2.361-6.048.499-7.943 2.339-8.829 3.683-13.696 2.852-10.337 9.276-8.066 10.471-7.425.105.056.198.115.291.19.525.41 2.737 2.119 5.116 3.787 2.667 1.865 2.547 9.22 1.791 12.906a1.91 1.91 0 0 1-.197.48c-.875 1.703-1.303 8.197-.603 13.693Z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M185.912 68.807c0 .074.246 6.044.626 7.842 2.279.693 5.325-1.337 5.638-2.007.312-.67-2.451-8.393-2.548-9.183-.093-.793-3.716 3.348-3.716 3.348Z",
    fill: "url(#additional-data-preview-empty_svg__P)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M178.96 63.668s.409 1.289 1.337 3.731c1.549 4.082 3.746 5.404 4.52 5.78.775.376 3.028.286 5.247-3.419s-.748-5.478-.823-5.705c-.026-.085-.406-.856-.871-1.806-1.065-2.156-3.754-2.975-5.817-1.731-1.646.99-2.815 2.026-3.593 3.15Z",
    fill: "url(#additional-data-preview-empty_svg__Q)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M192.321 74.005s1.568 1.937-.093 4.655c-1.657 2.715-1.021 45.058-.965 54.87.049 9.813 11.276 2.652 12.274 1.043 3.828-6.17-.868-14.4-1.251-18.869-.592-6.862-3.65-24.35-3.169-27.857.476-3.515 4.662-8.234-6.796-13.842Z",
    fill: "#2E2E2E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m195.27 124.608-5.068-18.213-16.351 4.089 5.489 18.053 15.93-3.929Z",
    fill: "#DBDEFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M187.901 114.934s-4.863 3.072-8.081 2.629c-1.757-.242-4.491-.205-5.228.633-.741.838-.391 4.733.741 5.422 1.136.688 4.234-.768 6.006-1.803 1.777-1.039 7.947-1.649 7.947-1.649s-.201-5.139-1.385-5.232Z",
    fill: "url(#additional-data-preview-empty_svg__R)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M198.26 78.656s5.296 3.173 7.176 23.047c1.233 12.992-18.28 19.219-18.28 19.219s-1.426-1.736-1.378-5.229c0 0 10.781-11.085 11.064-13.253.458-3.519-.324-10.65-.324-10.65l-1.203-6.978s.197-6.096 2.945-6.156Z",
    fill: "#62007A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__a",
    x1: 60.904,
    y1: 272.426,
    x2: 60.904,
    y2: 7.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__b",
    x1: 53.638,
    y1: 246.824,
    x2: 53.638,
    y2: -21.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__c",
    x1: 153.373,
    y1: 151.215,
    x2: 109.808,
    y2: 245.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__d",
    x1: 88.39,
    y1: 442.247,
    x2: 117.609,
    y2: 464.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__e",
    x1: 42.535,
    y1: 514.318,
    x2: 62.832,
    y2: 516.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__f",
    x1: -18.802,
    y1: 386.906,
    x2: 112.643,
    y2: 449.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__g",
    x1: 205.182,
    y1: 381.917,
    x2: 132.373,
    y2: 387.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__h",
    x1: 19.211,
    y1: 209.11,
    x2: 120.515,
    y2: 209.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__i",
    x1: 59.584,
    y1: 181.695,
    x2: 72.731,
    y2: 109.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__j",
    x1: 139.199,
    y1: 79.353,
    x2: 23.104,
    y2: 103.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__k",
    x1: 87.667,
    y1: 80.237,
    x2: 52.56,
    y2: 101.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__l",
    x1: 113.259,
    y1: 168.46,
    x2: 31.264,
    y2: 217.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#F8AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__m",
    x1: 244.207,
    y1: 243.159,
    x2: 117.628,
    y2: 244.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__n",
    x1: 136.786,
    y1: 315.753,
    x2: 137.034,
    y2: 315.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__o",
    x1: 135.986,
    y1: 337.312,
    x2: 138.14,
    y2: 337.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__p",
    x1: 135.684,
    y1: 294.443,
    x2: 137.839,
    y2: 294.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__q",
    x1: 183.509,
    y1: 278.853,
    x2: 183.755,
    y2: 278.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__r",
    x1: 182.773,
    y1: 309.858,
    x2: 184.929,
    y2: 309.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__s",
    x1: 182.339,
    y1: 248.101,
    x2: 184.495,
    y2: 248.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__t",
    x1: 223.813,
    y1: 265.228,
    x2: 224.06,
    y2: 265.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__u",
    x1: 223.008,
    y1: 286.251,
    x2: 225.161,
    y2: 286.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__v",
    x1: 222.715,
    y1: 244.458,
    x2: 224.868,
    y2: 244.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__w",
    x1: 136.137,
    y1: 322.888,
    x2: 256.182,
    y2: 322.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__x",
    x1: 153.659,
    y1: 336.764,
    x2: 153.904,
    y2: 336.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__y",
    x1: 152.761,
    y1: 344.741,
    x2: 154.914,
    y2: 344.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__z",
    x1: 152.65,
    y1: 329.032,
    x2: 154.805,
    y2: 329.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__A",
    x1: 200.354,
    y1: 296.205,
    x2: 200.6,
    y2: 296.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__B",
    x1: 199.549,
    y1: 317.287,
    x2: 201.706,
    y2: 317.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__C",
    x1: 199.254,
    y1: 275.377,
    x2: 201.411,
    y2: 275.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__D",
    x1: 240.614,
    y1: 276.313,
    x2: 240.86,
    y2: 276.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__E",
    x1: 239.783,
    y1: 293.68,
    x2: 241.936,
    y2: 293.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__F",
    x1: 239.541,
    y1: 259.2,
    x2: 241.695,
    y2: 259.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D769"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__G",
    x1: 117.462,
    y1: 268.036,
    x2: 126.724,
    y2: 268.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__H",
    x1: 165.008,
    y1: 173.863,
    x2: 184.487,
    y2: 173.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__I",
    x1: 188.095,
    y1: 172.436,
    x2: 207.832,
    y2: 172.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__J",
    x1: 212.572,
    y1: 173.136,
    x2: 232.162,
    y2: 173.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__K",
    x1: 164.074,
    y1: 174.325,
    x2: 229.662,
    y2: 174.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__L",
    x1: 177.151,
    y1: 50.703,
    x2: 207.657,
    y2: 87.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__M",
    x1: 185.89,
    y1: 54.759,
    x2: 212.841,
    y2: 97.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__N",
    x1: 186.831,
    y1: 65.479,
    x2: 176.987,
    y2: 65.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__O",
    x1: 178.077,
    y1: 70.856,
    x2: 166.483,
    y2: 83.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__P",
    x1: 196.274,
    y1: 84.009,
    x2: 186.567,
    y2: 68.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ED7936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#CF5C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#BC4A06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__Q",
    x1: 191.31,
    y1: 66.631,
    x2: 179.012,
    y2: 66.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B54400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6813E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "additional-data-preview-empty_svg__R",
    x1: 174.201,
    y1: 119.363,
    x2: 189.283,
    y2: 119.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6813E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54400"
  })))));
};
export { SvgAdditionalDataPreviewEmpty as ReactComponent };
export default __webpack_public_path__ + "efd30a6d7db02dc5c48e27c74dec29d2.svg";